// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"92f454cc","213":"448ae3c2","239":"e39fb35b","455":"d6505a62","898":"df5150a4"}[chunkId] + ".chunk.js";
};